import { Zone, OUT_PER_KM, IN_PER_KM, DOM_PER_KM } from "./rates";

export type AdminRatesConfig = {
  out: Record<Zone, number>;
  in: Record<Zone, number>;
  domestic: Record<string, number>;

  /** Vehicle price uplift vs BUS, in percent. BUS 0 = base price, SOLO 73 = +73%, trailer 155 = +155% */
  vehiclePercent: {
    bus: number;
    solo: number;
    trailer: number;
  };

  /** Global short-distance multiplier (e.g. 1.15 = +15%) */
  shortMultiplier: number;

  /** Global short-distance threshold for international routes (km) */
  shortKmThreshold: number;

  /** Per-country short-distance threshold for domestic routes (km). Falls back to shortKmThreshold. */
  domesticShortKmThreshold: Record<string, number>;
};

export const DEFAULT_ADMIN_RATES: AdminRatesConfig = {
  out: { ...OUT_PER_KM },
  in: { ...IN_PER_KM },
  domestic: { ...DOM_PER_KM },

  vehiclePercent: {
    bus: 0,
    solo: 73,
    trailer: 155,
  },

  shortMultiplier: 1.15,
  shortKmThreshold: 300,
  domesticShortKmThreshold: Object.fromEntries(
    Object.keys(DOM_PER_KM).map(cc => [cc, 300])
  ),
};